import { render, staticRenderFns } from "./customLayout.vue?vue&type=template&id=5746b3f2&"
import script from "./customLayout.vue?vue&type=script&lang=js&"
export * from "./customLayout.vue?vue&type=script&lang=js&"
import style0 from "./customLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports